import { supabase } from "./supabaseClient";

const STORAGE_KEY = "visitor_session_id";

function generateUuid() {
  if (typeof crypto?.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getVisitorSessionId() {
  if (typeof window === "undefined") {
    return null;
  }

  let sessionId = window.localStorage.getItem(STORAGE_KEY);
  if (!sessionId) {
    sessionId = generateUuid();
    window.localStorage.setItem(STORAGE_KEY, sessionId);
  }

  return sessionId;
}

export async function recordPageView() {
  if (!supabase || typeof window === "undefined") {
    return;
  }

  const session_id = getVisitorSessionId();
  if (!session_id) {
    return;
  }

  try {
    await supabase.from("page_views").insert([
      {
        session_id,
        page: document.title || window.location.pathname,
        url: window.location.href,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent,
      },
    ]);
  } catch (error) {
    console.debug("Visitor tracking insert failed:", error);
  }
}
